import { render, staticRenderFns } from "./ProductSVG.vue?vue&type=template&id=207169be&"
import script from "./ProductSVG.vue?vue&type=script&lang=js&"
export * from "./ProductSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports